import {ChangeEvent, useEffect, useState} from 'react';
import {Formik, Form} from 'formik';
import {useNavigate, useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import cn from 'classnames';

import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {labDetailSchema} from '../../contants';
import {RootState} from '../../../../../store/redux';
import LabAdditionalInfo from '../LabAdditionalInfo';
import DotsLoading from '../../../../../components/dotsLoading';
import CustomBadge from '../../../../../components/mazraeKit/customBadge';
import FormikTextArea from '../../../../../components/formikFileds/textArea';
import FormikLikeInput from '../../../../../components/formikFileds/likeInput';

import FloatingOnlySelectBottomSheet from '../../../../../module/newShop/advertisementRegisteration/floatingOnlySelectBottomSheet';
import {
  addCertificateLists,
  addRegisterStoreFormData,
  optionalIsOpen,
  preventRecall,
} from '../../../../../store/redux/registerStore';
import useCreateObjEditLab from '../../pages/comments/createObjEditLab';
import LicenseBottomSheet from '../bottomSheetLists/LicenseBottomSheet';
import {getLatLng} from '../../../../../utilities/helper/getLatLng';
import useGetLabDetail from '../../../../../services/hookService/getLabDetail/useGetLabDetail';

export const LabDetail = ({
  type,
  setCurrentStep,
  setIsSuccessModal,
  mode,
  mutateFn,
  isLoadingMutattion,
}: ILbaDetailProps) => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.registerStore);

  const selectLocation = useSelector(
    (state: RootState) => state.myStoreSelectedLocation,
  );

  const [openCertficateBottomSheet, setOpenCertficateBottomSheet] =
    useState(false);

  const [touched, setTouched] = useState<boolean>(false);

  const handleAfterSuccess = (labData: IGetLabDetail) => {
    addRegisterStoreFormData({
      title: labData.title,
      about: labData.about,
      address: labData.address,
      land_line: labData.land_line,
      logo: {file: null, logo: labData.logo},
      store_photo: {file: null, store_photo: labData.lab_photo},
      license: {file: null, license: labData.license},
    });
  };

  const {labData, labDataIsLoading} = useGetLabDetail({
    lab_guid: params.lab_guid,
    handleAfterSuccess,
  });

  const [certificateList, setCertificateList] = useState<ICertificateItem[]>(
    [],
  );

  useEffect(() => {
    if (state?.certificate) setCertificateList(state?.certificate);
  }, [state?.certificate]);

  useCreateObjEditLab(labData);

  return labDataIsLoading || params == undefined ? (
    <div className="flex flex-full justify-center items-center">
      <DotsLoading />
    </div>
  ) : (
    <Formik
      initialValues={{
        title: state.title,
        about: state.about,
        in_person_possibility: state.in_person_possibility,
        has_delivery: state.has_delivery,
        has_guarantee: state.has_guarantee,
        logo: state.logo,
        lab_photo: state.lab_photo,
        license: state.license,
        address: state.address,
        land_line: state.land_line,
        certificate: state.certificate,
      }}
      enableReinitialize
      validationSchema={labDetailSchema}
      onSubmit={values => {
        const optionalData = state.optionalRegisterFormData
          ? JSON.parse(state.optionalRegisterFormData)
          : {};

        if (state?.license?.file || state?.license?.license) {
          mutateFn({
            title: values.title || '',
            about: values.about,
            logo: state.logo?.logo ? undefined : state?.logo?.file,
            lab_photo: state?.lab_photo?.lab_photo
              ? undefined
              : state?.lab_photo?.file,
            license: state?.license?.license ? undefined : state?.license?.file,
            location: `POINT (${
              selectLocation.location && getLatLng(selectLocation.location)[0]
            } ${
              selectLocation.location && getLatLng(selectLocation.location)[1]
            })`,
            speciality: optionalData?.speciality,
            phone_number: state?.phone_number,
            land_line: values.land_line,
            from_hour: optionalData?.from_hour?.guid,
            to_hour: optionalData?.to_hour?.guid,
            result_from_day: optionalData?.result_from_day,
            result_to_day: optionalData?.result_to_day,
            certificate: state?.certificate?.map(item => item.code),
            //@ts-ignore
            lab_field_codes: state.lab_fields,
            guid: params.lab_guid || undefined,
            national_card: state?.national_card?.national_card
              ? undefined
              : state.national_card?.file,
            owner_name: state?.name,
            address: values?.address,
            city: selectLocation.id,
            state: selectLocation.state_id,
          });
        }
      }}
    >
      {({setFieldValue, values, errors, handleSubmit}) => {
        return (
          <div className=" flex flex-col mt-12 ">
            <Form className="flex flex-col gap-4">
              <section className="flex flex-col">
                <p className="mb-2 color-gray-1 text-md font-medium ">
                  <span>نام آزمایشگاه</span>
                  <span className="color-red-3">*</span>
                </p>
                {state.selectedInput?.id !== 2 && (
                  <span className="text-md mb-3">
                    نام فروشگاه خود را کوتاه و متناسب انتخاب کنید.
                  </span>
                )}
                <FormikLikeInput
                  name="title"
                  label="مثلا: کشاورز نوین"
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setFieldValue('title', e.target.value);
                  }}
                />
              </section>
              <section>
                <FormikTextArea
                  name="about"
                  placeholder=""
                  description="معرفی مختصر و هرآنچه که آزمایشگاه شما را منحصر به فرد می‌کند، بطور خلاصه بنویسید."
                  label="درباره آزمایشگاه"
                  rows={5}
                  labelClass="!text-md font-medium"
                  required={true}
                />
              </section>
              <section className="flex flex-col">
                <span className="text-md mb-3">تصاویر آزمایشگاه</span>
                <section className="flex flex-col mb-3">
                  <span className="mb-3 text-md">
                    لوگو آزمایشگاه را بارگذاری کنید.
                  </span>

                  {state?.logo?.file || state?.logo?.logo ? (
                    <div className="flex flex-col w-full">
                      <div className="w-full h-[128px] rounded-[8px] border-dashed border-[2px] border-gray-700 relative overflow-hidden">
                        <div
                          className="absolute rounded-[8px] bg-white flex items-center justify-center p-1 text-white left-2 top-2"
                          onClick={() => {
                            dispatch(
                              addRegisterStoreFormData({
                                ...state,
                                ...values,
                                logo: {file: null, logo: ''},
                              }),
                            );
                          }}
                        >
                          <SpanIcon className="icon-nameDelete text-xl text-red-600" />
                        </div>
                        <img
                          className="w-full h-[128px] object-cover"
                          src={
                            state?.logo?.logo
                              ? state?.logo?.logo
                              : (state?.logo?.file &&
                                  URL.createObjectURL(state?.logo?.file)) ||
                                ''
                          }
                          alt="upload_images"
                        />
                      </div>
                    </div>
                  ) : (
                    <div>
                      <label
                        htmlFor="logo"
                        className="flex gap-1 items-center justify-center text-md h-32 w-full rounded border-[2px] border-dashed text-gray-700"
                      >
                        <SpanIcon className="icon-nameImage-plus text-xxl" />
                      </label>
                      <input
                        onChange={event => {
                          dispatch(
                            addRegisterStoreFormData({
                              ...state,
                              ...values,
                              logo: {
                                file:
                                  (event?.target?.files &&
                                    event?.target?.files.length > 0 &&
                                    event.target.files[0]) ||
                                  null,
                                logo: '',
                              },
                            }),
                          );
                        }}
                        className="hidden"
                        type="file"
                        id="logo"
                        name="logo"
                        accept="image/png, image/jpeg"
                      />
                    </div>
                  )}
                </section>

                <section className="flex flex-col mb-3">
                  <span className="mb-3 text-md">
                    تصویری از محیط آزمایشگاه بارگذاری کنید.
                  </span>

                  {state?.lab_photo?.file || state?.lab_photo?.lab_photo ? (
                    <div className="flex flex-col w-full">
                      <div className="w-full h-[128px] rounded-[8px] border-dashed border-[2px] border-gray-700 relative overflow-hidden">
                        <div
                          className="absolute rounded-[8px] bg-white flex items-center justify-center p-1 text-white left-2 top-2"
                          onClick={() => {
                            dispatch(
                              addRegisterStoreFormData({
                                ...state,
                                ...values,
                                lab_photo: {file: null, lab_photo: ''},
                              }),
                            );
                          }}
                        >
                          <SpanIcon className="icon-nameDelete text-xl text-red-600" />
                        </div>
                        <img
                          className="w-full h-[128px] object-cover"
                          src={
                            state?.lab_photo?.lab_photo
                              ? state?.lab_photo.lab_photo
                              : (state?.lab_photo?.file &&
                                  URL.createObjectURL(state?.lab_photo.file)) ||
                                ''
                          }
                          alt="lab_photo"
                        />
                      </div>
                    </div>
                  ) : (
                    <div>
                      <label
                        htmlFor="lab_photo"
                        className="flex gap-1 items-center justify-center text-md h-32 w-full rounded border-[2px] border-dashed text-gray-700"
                      >
                        <SpanIcon className="icon-nameImage-plus text-xxl" />
                      </label>
                      <input
                        onChange={event => {
                          dispatch(
                            addRegisterStoreFormData({
                              ...state,
                              ...values,
                              lab_photo: {
                                file:
                                  (event?.target?.files &&
                                    event?.target?.files.length > 0 &&
                                    event.target.files[0]) ||
                                  null,
                                lab_photo: '',
                              },
                            }),
                          );
                        }}
                        className="hidden"
                        type="file"
                        id="lab_photo"
                        name="lab_photo"
                        accept="image/png, image/jpeg"
                      />
                    </div>
                  )}
                </section>

                <section className="flex flex-col mb-3">
                  <div className="flex mb-3">
                    <span>تصویر مجوز فعالیت</span>
                    <span className="text-red-700">*</span>
                  </div>
                  <div className="text-md text-gray-900 mb-2">
                    <span>تصویر مجوز فعالیت آزمایشگاه را بارگذاری کنید.</span>
                  </div>

                  {state?.license?.file || state?.license?.license ? (
                    <div className="flex flex-col w-full">
                      <div className="w-full h-[128px] rounded-[8px] border-dashed border-[2px] border-gray-700 relative overflow-hidden">
                        <div
                          className="absolute rounded-[8px] bg-white flex items-center justify-center p-1 text-white left-2 top-2"
                          onClick={() => {
                            dispatch(
                              addRegisterStoreFormData({
                                ...state,
                                ...values,
                                license: {file: null, license: ''},
                              }),
                            );
                          }}
                        >
                          <SpanIcon className="icon-nameDelete text-xl text-red-600" />
                        </div>
                        <img
                          className="w-full h-[128px] object-cover"
                          src={
                            state?.license?.license
                              ? state?.license.license
                              : (state?.license?.file &&
                                  URL.createObjectURL(state?.license.file)) ||
                                ''
                          }
                          alt="upload_images"
                        />
                      </div>
                    </div>
                  ) : (
                    <div>
                      <label
                        htmlFor="license"
                        className="flex gap-1 items-center justify-center text-md h-32 w-full rounded border-[2px] border-dashed text-gray-700"
                      >
                        <SpanIcon className="icon-nameImage-plus text-xxl" />
                      </label>
                      <input
                        onChange={event => {
                          dispatch(
                            addRegisterStoreFormData({
                              ...state,
                              ...values,
                              license: {
                                file:
                                  (event?.target?.files &&
                                    event?.target?.files.length > 0 &&
                                    event.target.files[0]) ||
                                  null,
                                logo: '',
                              },
                            }),
                          );
                        }}
                        className="hidden"
                        type="file"
                        id="license"
                        name="license"
                        accept="image/png, image/jpeg"
                      />
                    </div>
                  )}

                  {touched &&
                    !state?.license?.license &&
                    !state?.license?.file && (
                      <span className="text-xs text-red-500 pt-3">
                        تصویر مجوز آزمایشگاه خود را بارگذاری کنید
                      </span>
                    )}
                </section>
              </section>
              {state.selectedInput?.id === 2 && (
                <>
                  <section className={'flex flex-col'}>
                    <div className="flex mb-3">
                      <span>گواهینامه و اعتبارنامه‌ها</span>
                      <span className="color-red-3">*</span>
                    </div>
                    <span className={cn('text-md text-gray-900 mb-2')}>
                      گواهینامه و اعتبارنامه‌های کسب شده آزمایشگاه را انتخاب
                      کنید.
                    </span>
                    <FloatingOnlySelectBottomSheet
                      Placeholder="گواهی و اعتبارنامه ها"
                      wrapperClass="border-gray-700"
                      onClick={() => {
                        setOpenCertficateBottomSheet(true);
                      }}
                      errors={errors.certificate}
                    />
                  </section>
                  <div className="flex gap-1 whitespace-nowrap overflow-x-auto">
                    {state.certificate?.map(item => {
                      return (
                        <CustomBadge
                          title={item?.title}
                          onRemoveItem={() => {
                            const filteredArray = certificateList?.filter(
                              elem => elem.id !== item.id,
                            );
                            filteredArray &&
                              dispatch(addCertificateLists(filteredArray));
                            setCertificateList(filteredArray);
                          }}
                        />
                      );
                    })}
                  </div>
                </>
              )}

              <section className="flex flex-col gap-3">
                <span>
                  آدرس آزمایشگاه
                  <span className="color-red-3">*</span>
                </span>
                <div
                  className="flex gap-2 border-[1px] border-gray-700 w-full h-12 rounded  items-center p-2 text-gray-700"
                  onClick={() => {
                    dispatch(preventRecall(true));
                    dispatch(
                      addRegisterStoreFormData({
                        ...state,
                        ...values,
                      }),
                    );
                    dispatch(addCertificateLists(certificateList));
                    params?.lab_guid
                      ? navigate('/my-store-add-location-by-map', {
                          state: {
                            type: type,
                            lab_guid: params?.lab_guid,
                          },
                        })
                      : navigate('/my-store-add-location-by-map');
                  }}
                >
                  <i className="icon-nameLocation text-xxl" />
                  <span className="text-md">
                    {selectLocation.name || 'انتخاب محدوده'}
                  </span>
                </div>
                <div className=" flex gap-2 border-[1px] w-full h-12 rounded  items-center p-2 text-gray-700 border-gray-700">
                  <i className="icon-nameLocation text-xxl" />
                  <input
                    className="text-md w-full h-full outline-none"
                    placeholder="خیابان و شماره پلاک را وارد کنید"
                    onChange={e => setFieldValue('address', e.target.value)}
                    value={values.address}
                  />
                </div>
                <span className="text-red-500 text-xs">
                  {touched && !selectLocation.location && !state.address && (
                    <span className="text-red-500">
                      آدرس آزمایشگاه خود را وارد کنید
                    </span>
                  )}
                </span>
              </section>
              <section className="flex flex-col">
                <span className="mb-3 text-md">شماره تلفن ثابت</span>
                <FormikLikeInput
                  name="land_line"
                  type="number"
                  label="شماره تلفن ثابت"
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setFieldValue('land_line', e.target.value);
                  }}
                />
                <FloatingOnlySelectBottomSheet
                  Placeholder="سایر اطلاعات(اختیاری)"
                  wrapperClass="border-gray-700 mt-3"
                  onClick={() => {
                    dispatch(optionalIsOpen(true));
                    dispatch(
                      addRegisterStoreFormData({
                        ...state,
                        ...values,
                      }),
                    );
                    params?.lab_guid
                      ? navigate('/lab-store-additional-Main-info', {
                          state: {
                            type: type,
                            lab_guid: params?.lab_guid,
                          },
                        })
                      : navigate('/lab-store-additional-Main-info');
                  }}
                />
                <LabAdditionalInfo />
              </section>
            </Form>
            <section className="flex flex-1 h-12 gap-2 mt-4">
              <button
                className="flex flex-2 bg-white text-green-main justify-center items-center rounded border-[1px] border-green-main px-3"
                onClick={() => setCurrentStep(2)}
              >
                مرحله قبل
              </button>
              <button
                disabled={isLoadingMutattion}
                type="submit"
                className="flex flex-1 bg-green-main h-12 text-white justify-center items-center rounded"
                onClick={() => {
                  setTouched(true);
                  handleSubmit();
                }}
              >
                {isLoadingMutattion ? <DotsLoading /> : 'ثبت آزمایشگاه'}
              </button>
            </section>
            <LicenseBottomSheet
              openCertficateBottomSheet={openCertficateBottomSheet}
              setOpenCertficateBottomSheet={setOpenCertficateBottomSheet}
              certificateList={certificateList}
              setCertificateList={setCertificateList}
              onClick={() => {
                dispatch(
                  addRegisterStoreFormData({
                    ...state,
                    ...values,
                  }),
                );
                dispatch(addCertificateLists(certificateList));
              }}
            />
          </div>
        );
      }}
    </Formik>
  );
};

export default LabDetail;
